import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

/* eslint-disable no-param-reassign */

// based on the example at: https://prosemirror.net/examples/upload/
const addWidgetPlugin = new Plugin({
  state: {
    init() {
      return DecorationSet.empty
    },
    apply(tr, set) {
      // Adjust decoration positions to changes made by the transaction
      set = set.map(tr.mapping, tr.doc)

      // See if the transaction adds or removes any placeholders
      const action = tr.getMeta(this)
      if (action && action.add) {
        const { id, pos, widget } = action.add

        const createWidgetFn = typeof widget === 'function' ? widget : () => widget

        const deco = Decoration.widget(pos, createWidgetFn, {
          key: id,
          id,
          ignoreSelection: true,
        })
        set = set.add(tr.doc, [deco])
      } else if (action && action.remove) {
        set = set.remove(set.find(null, null, (spec) => spec.id === action.remove.id))
      }
      return set
    },
  },
  props: {
    decorations(state) {
      return this.getState(state)
    },
  },
})

export default addWidgetPlugin

export function findWidget(state, id) {
  const decos = addWidgetPlugin.getState(state)
  const found = decos.find(null, null, (spec) => spec.id === id)
  return found.length > 0 ? found[0].from : null
}
